import {IModalService} from "angular-ui-bootstrap";
import {Expiries} from "../expiry/Expiries";

import {IHttpService} from "angular";
import {KitchenParams, Recipe} from "./models/Recipe";

export class CookbookService {
    public static id = "cookbookService";

    /** @ngInject */
    public constructor(private $http: IHttpService, private $uibModal: IModalService) {
    }

    public async open(asAt: string, code: string, expiries: Expiries): Promise<Array<BaseTrade>> {
        const modalInstance = this.$uibModal.open({
            templateUrl: "app/apps/optionsCookbook/optionsCookbook.tpl.html",
            controller: "optionsCookbookCtrl as ctrl",
            size: "xl",
            resolve: {
                asAt: () => asAt,
                code: () => code,
                expiries: () => expiries.expiries
            }
        });

        const recipe: Recipe = await modalInstance.result;

        return await this.resolve(recipe, asAt);
    }

    public async resolve(recipe: Recipe, asAt?: string): Promise<Array<BaseTrade>> {
        const params: KitchenParams = {};
        if (asAt != null) {
            params.asAt = asAt;
        }

        const response = await this.$http.post<Array<BaseTrade>>(`/tradefloor/api/strategy/kitchen`, recipe, {params});
        return response.data!;
    }
}
